// extracted by mini-css-extract-plugin
export default {"header":"ZF","discountBanner":"aG","logo":"bG","maincontainer":"cG","videocontainer":"eG","videowelcome":"fG","videowrapper":"gG","videosale":"hG","loadingcontainer":"iG","footer":"jG","footerbutton":"kG","video":"lG","logoname":"mG"};
    if(module.hot) {
      // 1711717533504
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  